import { render } from "./IsoInChangedDate.vue?vue&type=template&id=878f9130"
import script from "./IsoInChangedDate.vue?vue&type=script&lang=js"
export * from "./IsoInChangedDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__